export default __webpack_public_path__ + "static/AntIcon232-9eaeba87b21f796fba3507806bf0b4bd.png";